import { ReactNode } from 'react'
import { FormGroup, Modal } from 'react-bootstrap'
import FormHandler from '../../../utils/Form/FormHandler'
import Field from '../../../utils/Form/Widgets/Field'
import AutocompleteSelect from '../../../utils/Form/Widgets/AutocompleteSelect'

type Props = {
  onHide: () => void
  show: boolean
  itemIdForUpdate?: string
  refreshFunction?: Function
}
class DataDirectory {
  directory_path?: string
  last_browser_time?: string
  file_structure?: string
}
class DataDirectoryEditModal extends FormHandler {
  constructor(props: Props) {
    super(props)
    this.state = { entity: new DataDirectory() }
  }

  getApiUrl(): string {
    return '/data_directory/save/' + this.props.itemIdForUpdate
  }
  getSingleUrl() {
    if (this.props.itemIdForUpdate === 'add') {
      return null
    } else {
      return '/data_directory/single/' + this.props.itemIdForUpdate
    }
  }

  getPostData(): object {
    return {
      data_directory: this.state.entity,
    }
  }
  render(): ReactNode {
    var state = this.state as any
    if (!state.entity.sftp_account) {
      state.entity.sftp_account = 0
    }
    return (
      <Modal
        id='kt_modal_create_company'
        aria-hidden='true'
        dialogClassName='modal-dialog modal-dialog-centered'
        size='lg'
        show={this.props.show}
        backdrop={true}
        onHide={this.props.onHide}
      >
        <form
          onSubmit={(event) => {
            this.handleSubmit(event)
              .then((response) => {
                if (this.props.refreshFunction && response?.data?.data?.entity_id) {
                  this.props.refreshFunction(response.data.data.entity_id)
                }
              })
              .catch((error) => {
                console.error('Error submitting form:', error)
              })
          }}
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {this.props.itemIdForUpdate === 'add' ? 'Add' : 'Edit'} Data Directory
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <FormGroup>
              <AutocompleteSelect
                title='SFTP Account'
                name='sftp_account'
                onChange={(event: any) => {
                  this.handleInputChange(event)
                }}
                defaultValue={state.entity.sftp_account}
                autoCompleteTokenUrl='/sftpaccounts/autocomplete'
                required={true}
              />
              <Field
                title='Directory Path'
                className='form-control'
                type='text'
                name='directory_path'
                onInput={(event: any) => {
                  this.handleInputChange(event)
                }}
                value={state.entity.directory_path ?? process.env.REACT_APP_DEFAULT_DATA_DIRECTORY}
              />
              <AutocompleteSelect
                title='File Structure'
                name='file_structure'
                autoCompleteTokenUrl='/import_file_structure_template/autocomplete'
                onChange={(event: any) => {
                  this.handleInputChange(event)
                }}
                defaultValue={state.entity.file_structure ?? 0}
              />
            </FormGroup>
          </Modal.Body>
          <Modal.Footer className='justify-content-end'>
            {this.props.itemIdForUpdate !== 'add' ? (
              <button
                type='button'
                onClick={(event) => {
                  this.handleDelete(event)
                    .then((response) => {
                      if (this.props.refreshFunction) {
                        this.props.refreshFunction('')
                      }
                    })
                    .catch((error) => {
                      console.error('Error deleting:', error)
                    })
                }}
                className='btn btn-danger btn-sm'
              >
                <span className='fa fa-trash'></span>
                Delete
              </button>
            ) : (
              <></>
            )}
            <button type='submit' className='btn btn-success btn-sm'>
              <span className='fa fa-floppy-save'></span>
              Save
            </button>
          </Modal.Footer>
        </form>
      </Modal>
    )
  }
}

export { DataDirectoryEditModal }
